module.exports = __webpack_public_path__ + "img/barrage_prize_05.8c771c2b.png";